import React from "react";
import SVG from "react-inlinesvg";
import { CloseIcon } from "@netapp/bxp-style/react-icons/Action";
import { Heading } from "../Typography";
import { Button } from "../Widgets";
import { StyledLink } from "../Widgets/StyledLink";
import styles from "./WizardHeader.module.scss";

const WizardHeader = ({ logo, Icon, label, children, onClose, closeLink, Widgets, headerColor = "text-title" }) => {
    return <header className={styles.base}>
        <div className={styles.label}>
            {logo && <SVG src={logo}/>}
            {Icon && <Icon/>}
            <Heading level={20} color={headerColor} ellipsis>{label}</Heading>
        </div>
        {children && <div className={styles.contents}>
            {children}
        </div>}
        {!children && <div/>}
        <div className={styles['widgets-container']}>
            {Widgets && <Widgets/>}
            {onClose && <Button variant="icon" color="secondary" onClick={onClose} className={styles.close}><CloseIcon/></Button>}
            {closeLink && <StyledLink type="icon" color="secondary" className={styles.close} to={closeLink}><CloseIcon/></StyledLink>}
        </div>
    </header>
}

export default WizardHeader;
